
import { Usuario } from './usuario';
import { Venda } from './venda';

export class LivroCaixa {

  id:  number | null = null;
  descricao: string = '';
  valor: number = 0;
  tipoLancamento?: TipoLancamento;
  usuarioId: number = 0;
  vendaId: number = 0;

  dataCadastro: string | null = null;
  dataUltimaModificacao: string | null = null;
}

export enum TipoLancamento {
  E = 'Entrada',
  S = 'Saída'
}
